import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SelectAndResetFilterControls.module.scss";

export interface ISelectAndResetFilterControls {
  onReset?: () => void;
  customLabel?: string;
  ariaLabel?: string;
}
export const SelectAndResetFilterControls: VoidFunctionComponent<ISelectAndResetFilterControls> = ({onReset, customLabel, ariaLabel}) => {

  return <div className={s.selectAndResetButtons}>
    <button onClick={() => onReset?.()} aria-label={ariaLabel ? ariaLabel : `Reset the filter`}>{customLabel ? customLabel : `Reset`}</button>
  </div>;
}
